import { render } from "./AcercaDe.vue?vue&type=template&id=f9245d08&scoped=true"
import script from "./AcercaDe.vue?vue&type=script&lang=js"
export * from "./AcercaDe.vue?vue&type=script&lang=js"

import "./AcercaDe.vue?vue&type=style&index=0&id=f9245d08&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9245d08"]])

export default __exports__